module.exports = __webpack_public_path__ + "static/media/has.2e0444f.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/person/has.mp4
// module id = pcIJ
// module chunks = 1